import * as React from 'react';

import { METRICS_CARDS } from '~/containers/Dashboard/OverView/constants';
import { QueryServiceMetricsConfigKey } from '~/types/query-service-helpers';

import { usePersonalDashboard } from '../../Provider/PersonalDashboardProvider';

export const usePersonalDashboardOverview = () => {
  const { metrics: personalMetrics } = usePersonalDashboard();

  const shownMetrics = personalMetrics.filter((m) => m.status === 'show');

  const shouldShowAddMetric = personalMetrics.some(
    (m) => m.status === 'hidden'
  );

  const metrics = METRICS_CARDS.filter((m) =>
    shownMetrics.some((sm) => sm.id === m.id)
  );

  const [selectedMetricId, setSelectedMetricId] =
    React.useState<QueryServiceMetricsConfigKey>(metrics[0]?.id ?? 'Views');

  const selectedMetric = React.useMemo(
    () =>
      METRICS_CARDS.find((m) => m.id === selectedMetricId) ?? METRICS_CARDS[0],
    [selectedMetricId]
  );

  return {
    metrics,
    selectedMetric,
    setSelectedMetricId,
    shouldShowAddMetric,
  };
};
